import { render, staticRenderFns } from "./cooperationCase.vue?vue&type=template&id=0c4f5106&scoped=true&"
import script from "./cooperationCase.vue?vue&type=script&lang=js&"
export * from "./cooperationCase.vue?vue&type=script&lang=js&"
import style0 from "./cooperationCase.vue?vue&type=style&index=0&id=0c4f5106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4f5106",
  null
  
)

export default component.exports